import api from '@lib/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchData } from '../../tools/_fetch-data-helper';

export const fetchGallery = createAsyncThunk('gallerySlice/fetchGallery', async (_, thunkApi) => {
  return fetchData(api.urlGallery, thunkApi);
});

const initialState = {
  gallery: null,
  fetchError: false,
};

export const gallerySlice = createSlice({
  name: 'gallerySlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchGallery.fulfilled, (state, action) => {
        state.gallery = action.payload;
      })
      .addCase(fetchGallery.rejected, state => {
        state.fetchError = true;
      });
  },
});

export const gallerySelector = state => state.galleryInfo.gallery;
export const fetchErrorSelector = state => state.galleryInfo.fetchError;

export default gallerySlice.reducer;
